export const setContainerParameters = 'setContainerParameters';
export const setContainerPriceMaps = 'setContainerPriceMaps';
export const addPickupPlaces = 'addPickupPlaceList';
export const setTemplateData = 'setTemplateData';
export const setRefreshTokenLoading = 'setRefreshTokenLoading';
export const addContainersForSelect = 'addContainersForSelect';
export const setLastFilteredContainers = 'setLastFilteredContainers';
